module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-battle-schedule-64-active.a2730e0b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-battle-schedule-64-active.png
// module id = 3182
// module chunks = 11